export const LockedWrapper = ({ children, isActive, onHover, onLeave }) => {
    return (
        <div
            className="relative z-0"
            onMouseEnter={onHover}
            onMouseLeave={onLeave}
        >
            <div className={`transition-opacity duration-300 ${isActive ? 'opacity-100' : 'opacity-20'}`}>
                {children}
            </div>
        </div>
    );
};
